import { Dropdown, Table } from "antd";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { MdMoreHoriz } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";
import { documentState } from "utils/helpers/documentTemplates";
import { usedInProducts } from "./document-filters";

export const ROW_ACTIONS = {
  DUPLICATE: "duplicate",
  DOWNLOAD: "download",
  DELETE: "delete",
};

const stopPropagation = (event) => event.stopPropagation();

const View = ({ data, onOpen, onAction }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const LIST = t("LIST", { returnObjects: true });

  const menuItems = [
    { key: ROW_ACTIONS.DUPLICATE, label: LIST.ACTIONS.DUPLICATE },
    { key: ROW_ACTIONS.DOWNLOAD, label: LIST.ACTIONS.DOWNLOAD },
    { type: "divider" },
    { key: ROW_ACTIONS.DELETE, label: LIST.ACTIONS.DELETE, danger: true },
  ];

  const usedInTitle = (template) =>
    isEmpty(template.usages)
      ? LIST.USED_IN_NONE
      : t("LIST.USED_IN", { products: usedInProducts(template, t) });

  const columns = [
    {
      title: LIST.COLUMNS.DOCUMENT,
      dataIndex: "name",
      render: (name) => <span className="dynamic-documents__name">{name}</span>,
    },
    {
      title: LIST.COLUMNS.STATE,
      key: "state",
      width: 280,
      render: (_, template) => {
        const state = documentState(template);
        return (
          <span
            className={`dynamic-documents__state dynamic-documents__state--${state}`}
          >
            {LIST.STATES[state]}
          </span>
        );
      },
    },
    {
      title: "",
      key: "actions",
      align: "right",
      width: 56,
      render: (_, template) => (
        <span onClick={stopPropagation}>
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: menuItems,
              onClick: ({ key }) => onAction(key, template),
            }}
          >
            <button
              type="button"
              className="dynamic-documents__more"
              aria-label={LIST.COLUMNS.ACTIONS}
              title={LIST.COLUMNS.ACTIONS}
            >
              <MdMoreHoriz size={20} />
            </button>
          </Dropdown>
        </span>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      className="table__wrapper"
      columns={columns}
      rowKey="id"
      pagination={false}
      scroll={{ x: true }}
      locale={{ emptyText: LIST.EMPTY.NO_MATCH }}
      rowClassName="dynamic-documents__list-row"
      onRow={(template) => ({
        onClick: () => onOpen(template),
        title: usedInTitle(template),
      })}
    />
  );
};

export default View;
